export class StringConstants {
  static readonly role_Classification: string = 'Classification';
  static readonly role_ClassificationManager: string = 'Classification Manager';
  static readonly role_SuperAdmin: string = 'Super Admin';

  static readonly fcdcEmail: string = 'fcdc@gmail.com';

  static readonly proposalStatusCategory_open: string = 'open';
  static readonly proposalStatusCategory_current: string = 'current';
  static readonly proposalStatusCategory_published: string = 'published';
  static readonly proposalStatusCategory_archived: string = 'archived';

  static readonly proposalStatus_inProgress: string = 'In Progress';
  static readonly proposalStatus_readyForReview: string = 'Ready for Review';
  static readonly proposalStatus_inReview: string = 'In Review';
  static readonly proposalStatus_finalReview: string = 'Final Review';
  static readonly proposalStatus_readyForLegal: string = 'Ready for Legal';
  static readonly proposalStatus_legalReview: string = 'Legal Review';
  static readonly proposalStatus_research: string = 'Research';
  static readonly proposalStatus_complete: string = 'Complete';
  static readonly proposalStatus_docketed: string = 'Docketed';
  static readonly proposalStatus_docketPublished: string = 'Published-Docket';
  static readonly proposalStatus_dispoBulletinPublished: string = 'Published-DispoBulletin';
  static readonly proposalStatus_supplementPublished: string = 'Published-Supplement';
  static readonly proposalStatus_withdrawn: string = 'Withdrawn';
  static readonly proposalStatus_deferred: string = 'Deferred';
  static readonly proposalStatus_disapproved: string = 'Disapproved';
  static readonly proposalStatus_modifiedAndApproved: string = 'Modified and Approved';
  static readonly proposalStatus_subjectApproved: string = 'Subject Approved';
  static readonly proposalStatus_archived: string = 'Archived';

  static readonly proposalEditability_managersAndAbove = 'managers';
  static readonly proposalEditability_all = 'all';
  static readonly proposalEditability_none = 'none';

  static readonly docketStatus_published: string = 'Published';
  static readonly docketStatus_inProgress: string = 'In Progress';
  static readonly docketStatus_readyForReview: string = 'Ready for Review';
  static readonly docketStatus_inReview: string = 'In Review';
  static readonly docketStatus_complete: string = 'Complete';
  static readonly docketStatus_docketPublished: string = 'Published-Docket';

  /** Mirrors FunctionJobFileType.Publishing on the API - the file types a generation job accepts. */
  static readonly fileType_docket: string = 'Docket';
  static readonly fileType_proposal: string = 'Proposal';
  static readonly fileType_dispositionBulletin: string = 'Disposition Bulletin';
  static readonly fileType_supplement: string = 'Supplement';
  static readonly fileType_indexToArticles: string = 'Index to Articles';
  static readonly fileType_dispositionBulletin_csv: string = 'Disposition Bulletin CSV';
  static readonly fileType_dispositionBulletin_publicWebsite_csv: string = 'Public Website';
  static readonly fileType_dispositionBulletin_nmfcBookSection_csv: string = 'NMFC Book section';

  static readonly disposistionBulletinStatusCategory_open: string = 'open';
  static readonly disposistionBulletinStatusCategory_published: string = 'published';
  static readonly disposistionBulletinStatusCategory_archived: string = 'archived';

  static readonly dispositionBulletin_DocketSubject_Outcome_ApprovdAsDocketed: string = 'Approved as Docketed';
  static readonly dispositionBulletin_DocketSubject_Outcome_ApprovedAsModified: string = 'Approved as Modified';
  static readonly dispositionBulletin_DocketSubject_Outcome_Withdrawn: string = 'Withdrawn';
  static readonly dispositionBulletin_DocketSubject_Outcome_Deferred: string = 'Deferred';
  static readonly dispositionBulletin_DocketSubject_Outcome_Disapproved: string = 'Disapproved';
}
